import { Component, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'fury-quickpanel',
  templateUrl: './quickpanel.component.html',
  styleUrls: ['./quickpanel.component.scss']
})
export class QuickpanelComponent {
  @Input() closeQuickPanel: EventEmitter<boolean>;
}
